'use client'

import React, { ReactNode, useEffect, useState } from 'react'
import { cn } from '@/utils/ui'
import { MaxWidthGlobal } from '@/ui/layout/Gutter/new/MaxWidthGlobal'
import { NavBar } from '@/ui/layout/Header/NavBar'
import { Icon } from '@/ui/atoms/Icon'
import { useWikiContext } from '@/context/wikiContext'
import * as console from 'node:console'
import { ContentGutter } from '@/ui/layout/Gutter/new/ContentGutter'
import { PAGE_NAV_WIDTH } from '@/ui/layout/Gutter/new/const'
import breadcrumbs from '@/ui/components/Breadcrumbs'

// Define types in a separate section for better organization
type MaxWidthType = 'narrow' | 'medium' | 'wide' | 'full'

interface PageLayoutProps {
  children: React.ReactNode
  maxWidth?: MaxWidthType
  className?: string
}

interface RootGutterProps {
  children: React.ReactNode
  breadcrumbs?: ReactNode
  className?: string
}

interface ProductGroupGutterProps {
  breadcrumbs: ReactNode
  onPageNav: ReactNode
  children: ReactNode | ReactNode[]
  hero?: ReactNode
  className?: string
}

// Constants for reusable values

export const RootGutter: React.FC<RootGutterProps> = ({
  children,
  breadcrumbs,
  className: classNameFromProps,
}) => {
  return (
    <div
      className={cn(
        classNameFromProps,
        `mx-auto grid grid-cols-[20px_0px_1fr_0px_20px] sm:grid-cols-[20px_20px_1fr_20px_20px] md:grid-cols-[20px_80px_1fr_80px_20px] w-full [&>*]:col-start-2 [&>*]:col-end-5`,
      )}
    >
      {breadcrumbs && <div className={'sticky top-20 lg:top-[96px] z-40'}>{breadcrumbs}</div>}
      {children}
    </div>
  )
}

/**
 * Wiki layout component with side navigation
 */

/**
 * Product group layout component
 */
export const ProductGroupGutter: React.FC<ProductGroupGutterProps> = ({
  breadcrumbs,
  onPageNav,
  children,
  hero,
  className,
}: ProductGroupGutterProps) => {
  return (
    <MaxWidthGlobal className={className}>
      <RootGutter breadcrumbs={breadcrumbs}>
        <div className={'relative w-full mt-5'}>
          {hero}
          <ContentGutter isNarrow={false} onPageNav={onPageNav}>
            {children}
          </ContentGutter>
        </div>
      </RootGutter>
    </MaxWidthGlobal>
  )
}

/**
 * Content layout with side navigation
 */

// Helper components extracted to improve readability
